import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { ElementzDateFormats } from '@app/core/shared/helpers/date-time.util';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: string | number | Date): Date | null {
    if (typeof value === 'string' && value.includes('/')) {
      const parts = value.split('/');
      const day = Number(parts[0]);
      const month = Number(parts[1]) - 1;
      const year = Number(parts[2]);

      if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
        return new Date(year, month, day);
      }
    }

    if (value instanceof Date) {
      return value;
    }

    return null;
  }

  override format(date: Date, displayFormat: unknown): string {
    if (displayFormat === ElementzDateFormats.TIME) {
      return `${this._to2digit(date.getHours())}:${this._to2digit(date.getMinutes())}`;
    }

    return `${this._to2digit(date.getDate())}/${this._to2digit(date.getMonth() + 1)}/${date.getFullYear()}`;
  }

  private _to2digit(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  override getDayOfWeekNames(): string[] {
    return super.getDayOfWeekNames('narrow');
  }
}
